import React from 'react';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router-dom';

import {graphql} from 'react-apollo';
import Table from '@appComponents/Table';
import {GetMappedIsoCodes} from '@graphql/country/query';

import {rowRenderer} from './clientGeoRestrictionsRowRenderer';
import {columns} from './clientGeoRestrictionsColumns';

export const ClientGeoRestrictionsTable = (props) => {
    const {clientId, clientPackageId, data, geoRestrictions, loading} = props;
    const history = useHistory();

    return (
        <div className='geo_restrictions__table'>
            <Table
                columns={columns}
                data={geoRestrictions}
                loading={loading}
                name='geoRestrictionsList'
                noDataText='No geo restrictions found'
                pagination={false}
                rowRenderer={
                    (column, row) => rowRenderer(column, row, {clientId, clientPackageId, data, history})
                }
            />
        </div>
    );
};

ClientGeoRestrictionsTable.propTypes = {
    clientId: PropTypes.number.isRequired,
    clientPackageId: PropTypes.number.isRequired,
    data: PropTypes.shape({
        mappedIsoCodes: PropTypes.shape({
            countries: PropTypes.object,
            subdivisions: PropTypes.object,
        }),
    }),
    geoRestrictions: PropTypes.array,
    loading: PropTypes.bool,
};
ClientGeoRestrictionsTable.defaultProps = {
    data: {
        mappedIsoCodes: {
            countries: {},
            subdivisions: {},
        },
    },
    geoRestrictions: [],
    loading: false,
};
ClientGeoRestrictionsTable.displayName = 'GeoRestrictionsTable';

export default graphql(GetMappedIsoCodes)(ClientGeoRestrictionsTable);
